export interface SSERideStatus {
  event_id: string
  uuid: string
  type: number
  data: Data
  fired_at: number
}

export enum SSERideStatusEnum {
  REQUESTED = 1,
  ACCEPTED = 2,
  CANCELLED_BY_DRIVER = 4,
  ARRIVED = 5,
  STARTED = 6,
  FINISHED = 7,
}

export enum SSERideStatusFlag {
  ACCEPTED = 5,
  ARRIVED = 72,
  STARTED = 3,
  FINISHED = 4,
  ARRIVED_DESTINATION = 21,
  CANCELLED_BY_DRIVER = 7,
}

interface Data {
  aps: Aps
  bearing: number
  category: string
  chat_enabled: number
  coupon: string
  currency: string
  current_location_latitude: number
  current_location_longitude: number
  customer_fare: number
  distance: number
  driver_car_image: string
  driver_car_no: string
  driver_id: number
  drop_location_address: string
  drop_location_address_name: string
  emergency_no: string
  engagement_id: number
  eta: number
  event_group: string
  event_id: string
  fare: number
  fare_details: Faredetails
  fare_factor: number
  fare_flat_surge: number
  flag: number
  free_ride: number
  icon_set: string
  is_be_now: number
  is_pooled: number
  is_pro_driver: boolean
  marker_icon: string
  message: string
  message_ios: string
  note?: any
  op_drop_latitude: number
  op_drop_longitude: number
  phone_no: string
  pickup_latitude: number
  pickup_location_address: string
  pickup_location_address_name: string
  pickup_longitude: number
  preferred_payment_mode: number
  promotion: string
  push_call_driver: string
  rating: number
  request_e_invoiced: number
  ride_time: number
  session_id: number
  sound: string
  start_time: string
  title: string
  title_ios: string
  user_image: string
  user_name: string
  user_type: number
  uuid: string
  vehicle_info: Vehicleinfo
  vehicle_name: string
  vehicle_type: number
}

interface Vehicleinfo {
  brand: string
  model: string
  color?: string
  num_seats: number
}

interface Faredetails {
  accept_subsidy_after_threshold: number
  accept_subsidy_before_threshold: number
  accept_subsidy_per_km: number
  accept_subsidy_per_min: number
  accept_subsidy_threshold_distance: number
  accept_subsidy_threshold_time: number
  business_id: number
  cancel_threshold_distance: number
  cancel_threshold_time: number
  cancellation_charges: number
  city: number
  created_at: string
  display_base_fare: string
  end_time: string
  fare_change_destination: number
  fare_fixed: number
  fare_minimum: number
  fare_per_baggage: number
  fare_per_km: number
  fare_per_km_after_threshold: number
  fare_per_km_before_threshold: number
  fare_per_km_threshold_distance: number
  fare_per_min: number
  fare_per_night: number
  fare_per_time_unit: number
  fare_per_waiting_min: number
  fare_stop_point_charge: number
  fare_threshold_distance: number
  fare_threshold_time: number
  fare_threshold_waiting_time: number
  fare_type: number
  fuel_fee_cfg: string
  geofence_id: number
  geofence_type: number
  id: number
  is_applicable: number
  max_distance: number
  min_distance: number
  night_fare_applicable: number
  operator_id: number
  per_ride_driver_subsidy: number
  return_factor: number
  ride_type: number
  schedule_night_time_config: string
  scheduled_surcharge_cap: number
  scheduled_surge_cap: number
  scheduled_trip_fee: number
  start_time: string
  tax_percentage: number
  time_unit: number
  toggle_name: string
  type: number
  updated_at: string
  vehicle_type: number
}

interface Aps {
  alert: Alert
  "content-available": number
  sound: string
}

interface Alert {
  body: string
  title: string
}

export interface DriverAcceptedData {
  aps: Aps
  bearing: number
  category: string
  chat_enabled: number
  coupon: string
  currency: string
  current_location_latitude: number
  current_location_longitude: number
  customer_fare: number
  distance: number
  driver_car_image: string
  driver_car_no: string
  driver_id: number
  drop_location_address: string
  drop_location_address_name: string
  emergency_no: string
  engagement_id: number
  eta: number
  event_group: string
  event_id: string
  fare: number
  fare_details: Faredetails
  fare_factor: number
  fare_flat_surge: number
  flag: number
  free_ride: number
  icon_set: string
  is_be_now: number
  is_pooled: number
  is_pro_driver: boolean
  marker_icon: string
  message: string
  message_ios: string
  note?: any
  op_drop_latitude: number
  op_drop_longitude: number
  phone_no: string
  pickup_latitude: number
  pickup_location_address: string
  pickup_location_address_name: string
  pickup_longitude: number
  preferred_payment_mode: number
  promotion: string
  push_call_driver: string
  rating: number
  request_e_invoiced: number
  ride_time: number
  session_id: number
  sound: string
  start_time: string
  title: string
  title_ios: string
  user_image: string
  user_name: string
  user_type: number
  uuid: string
  vehicle_info: Vehicleinfo
  vehicle_name: string
  vehicle_type: number
}

interface Vehicleinfo {
  brand: string
  model: string
}

interface Faredetails {
  accept_subsidy_after_threshold: number
  accept_subsidy_before_threshold: number
  accept_subsidy_per_km: number
  accept_subsidy_per_min: number
  accept_subsidy_threshold_distance: number
  accept_subsidy_threshold_time: number
  business_id: number
  cancel_threshold_distance: number
  cancel_threshold_time: number
  cancellation_charges: number
  city: number
  created_at: string
  display_base_fare: string
  end_time: string
  fare_change_destination: number
  fare_fixed: number
  fare_minimum: number
  fare_per_baggage: number
  fare_per_km: number
  fare_per_km_after_threshold: number
  fare_per_km_before_threshold: number
  fare_per_km_threshold_distance: number
  fare_per_min: number
  fare_per_night: number
  fare_per_time_unit: number
  fare_per_waiting_min: number
  fare_stop_point_charge: number
  fare_threshold_distance: number
  fare_threshold_time: number
  fare_threshold_waiting_time: number
  fare_type: number
  fuel_fee_cfg: string
  geofence_id: number
  geofence_type: number
  id: number
  is_applicable: number
  max_distance: number
  min_distance: number
  night_fare_applicable: number
  operator_id: number
  per_ride_driver_subsidy: number
  return_factor: number
  ride_type: number
  schedule_night_time_config: string
  scheduled_surcharge_cap: number
  scheduled_surge_cap: number
  scheduled_trip_fee: number
  start_time: string
  tax_percentage: number
  time_unit: number
  toggle_name: string
  type: number
  updated_at: string
  vehicle_type: number
}
